export const usePreventScreenCapture = () => null;
